import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const transparentImageOnImageDropzoneInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("transparent-image-on-image-dropzone").default("transparent-image-on-image-dropzone"),
      tileId: z.string().default(""),
      tileKey: z.string().default("")
    }),
    shouldValidate: node => typeof node.validation.acceptedTileKey === "string",
    validate: (node, entry) => node.validation.acceptedTileKey === entry.tileKey,
    parseLegacyDetailItem: (item, context) => {
      if (context.relatedTask.taskType === "PlaceItems" && context.relatedTask.answerType === "TransparentImagesOnImage" && typeof item === "number") {
        const typedTask = context.relatedTask;
        const tile = typedTask.__orderedTiles[context.indexInDetails];
        const selectedDropzoneForTile = typedTask.content[item];
        if (tile && selectedDropzoneForTile) {
          return [selectedDropzoneForTile.id, {
            type: "transparent-image-on-image-dropzone",
            tileId: tile.id,
            tileKey: tile.tileKey
          }];
        }
      }
      return undefined;
    }
  },
  schema: z.object({
    x: z.number(),
    y: z.number(),
    w: z.number(),
    h: z.number()
  }),
  postprocessSchemaInput(input, context) {
    const expectedTile = context.tiles.find(it => typeof it.correctAnswer === "number" && context.indicesForDropzone.includes(it.correctAnswer));
    return {
      id: `${context.taskId}-${context.index}`,
      nodeType: "transparent-image-on-image-dropzone-input",
      placement: {
        x: input.x,
        y: input.y,
        height: input.h,
        width: input.w
      },
      meta: {
        maskSrc: expectedTile?.src ?? null
      },
      validation: {
        acceptedTileKey: expectedTile ? expectedTile.tileKey : null
      }
    };
  }
});

export { transparentImageOnImageDropzoneInput };
//# sourceMappingURL=input.dropzone.js.map
